"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RED_BACKGROUND = exports.RED = exports.YELLOW_BACKGROUND = exports.YELLOW = exports.BLACK = exports.GREY4 = exports.GREY3 = exports.GREY2 = exports.GREY1 = exports.PALE_GREEN = exports.LIGHT_GREY = exports.WHITE = exports.AMBER = exports.BLUE = exports.TURQUOISE = exports.ORANGE = exports.DARK_GREEN = exports.SWEGON_GREEN = void 0;
// Primary colors
exports.SWEGON_GREEN = "#39AA0D";
exports.DARK_GREEN = "#277D32";
// Secondary colors
exports.ORANGE = "#C14B0F";
exports.TURQUOISE = "#00857F";
exports.BLUE = "#18B8D7";
exports.AMBER = "#C88104";
// Background colors
exports.WHITE = "#FFFFFF";
exports.LIGHT_GREY = "#F5F5F5";
exports.PALE_GREEN = "#E9F2E5";
// Neutrals
// export const WHITE = '#FFFFFF'
// export const LIGHT_GREY = '#F5F5F5'
exports.GREY1 = "#D1D2D2";
exports.GREY2 = "#AFAFAF";
exports.GREY3 = "#737473";
exports.GREY4 = "#434343";
exports.BLACK = "#191919";
// Custom colors
exports.YELLOW = "#FFC20E";
exports.YELLOW_BACKGROUND = "#FFF8EB";
exports.RED = "#D02D2C";
exports.RED_BACKGROUND = "#FDF3EF";
//# sourceMappingURL=colors.js.map